import { subDays } from 'date-fns';

export const fireEvent = (eventName, payload) => {
  if (!ecom.events) {
    ecom.events = {};
  }
  ecom.events[eventName] = {
    event: eventName,
    data: payload,
  };
  const event = new CustomEvent(eventName, {
    payload,
  });
  document.dispatchEvent(event);
};

export const prefillEmail = (email) => {
  const emailInput = document.querySelector(
    '#abandon-cart-modal #emailAddress'
  );
  if (emailInput) {
    emailInput.value = email;
  }
};

export const onOverviewOrCheckout = () => {
  const { pathname } = window.location;
  const result = ['/bookings', '/checkout', '/cart'].find((path) => {
    const noSlashPath = pathname.replace(/\/+$/, ''); // Remove trailing slash

    return noSlashPath.endsWith(path);
  });

  return Boolean(result);
};

export const getBooking = () => {
  const { redux_store: reduxStore } = ecom;
  const storeState = reduxStore?.getState();

  return storeState?.booking?.current || {};
};

export const getCheckoutForm = () => {
  const { redux_store: reduxStore } = ecom;
  const storeState = reduxStore?.getState();

  return (
    storeState?.ui?.sealink?.ferryGrouping?.[0]?.values?.checkoutForm || {}
  );
};

const STORAGE_KEY = 'abandonedCartModal';

export const getStorage = () => {
  let parsed;

  try {
    parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || [];
  } catch (error) {
    parsed = [];
  }

  return parsed;
};

export const removeOutDated = () => {
  const existingData = getStorage();
  const aWeekAgo = subDays(new Date(), 7).getTime();
  const validData = existingData.filter(
    ({ createdAt }) => createdAt > aWeekAgo
  );

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(validData));
};

export const storeModalState = (bookingId) =>
  window.localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify([
      ...getStorage(),
      {
        id: bookingId,
        createdAt: Date.now(),
      },
    ])
  );

export const inStorage = (bookingId) => {
  if (!bookingId) {
    return false;
  }

  const existingData = getStorage();

  return Boolean(existingData.find(({ id }) => id === bookingId));
};
